import React from "react";
import NumberedHeading from "../components/NumberedHeading";
import SectionBgImg from "../components/SectionBgImg";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";
import { useTranslation } from "react-i18next";

const Solutions = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result");
  return (
    <div className="py-20 md-max:py-5">
      <NumberedHeading
        number={"3"}
        title={t("solutions.title")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <div className="my-10 px-[20rem] md-max:px-[1rem] relative">
        <SectionBgImg className={"top-1/2 -translate-y-1/2"} />
        <div className="bg-white shadow-xl z-10 relative rounded-xl p-5 grid grid-cols-2 md-max:grid-cols-1 gap-x-5 gap-y-6">
            {data?.challenge_solutions?.slice(0,4)?.map((item, index) => (
              <div key={index} className="col-span-1 flex flex-col items-center bg-[#F1F7FF] text-center gap-4 px-9 py-10 md-max:px-4 md-max:py-6 rounded-xl">
                <div className="flex flex-col items-center gap-2">
                <HiOutlineAcademicCap size={32} className="text-primary-blue" />
                <p className="font-semibold text-2xl md-max:text-[22px]">{item?.title}</p>
                </div>
                <p className="text-sm text-[#4B5563] font-light md-max:text-[16px]">{item?.description}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;
